import { FormEntry, ImageUpload, ProtectedImg } from "components";
import { Controller } from "react-hook-form";
import { Row, Label, Col, FormGroup } from "reactstrap";
import { useQuery } from "react-query";
import defaultImage from "assets/img/image_placeholder.jpg";
import Select from "react-select";
import ReactRoundedImage from "react-rounded-image";
import apiService from "services/api";

export const RequiredFields = ({
  register,
  errors,
  isParentLoading,
  isStudentLoading,
  isCentreLoading,
  nftPath,
  control,
  fileInputRef,
  centres = [],
  parentOptions = [],
}) => {
  const { data: teacherSelections, isLoading: isLoadingTeacherSelections } =
    useQuery("teachers", () =>
      apiService.staff.get().then((teachers) => [
        {
          value: null,
          label: "Unassigned",
        },
        ...teachers
          .map((teacher) => ({
            value: teacher.id,
            label: teacher.fullName,
          }))
          .sort((prev, curr) => prev.label.localeCompare(curr.label)),
      ]),
    );

  return (
    <Row className="mb-5">
      <Col md={6}>
        <div className="text-light ml-2 mb-2">
          <small>Required</small>
        </div>
        <div className="input-group mb-3">
          <div className="input-group-prepend">
            <span className="input-group-text">Name</span>
          </div>
          <input
            type="text"
            className="form-control text-light"
            name="firstName"
            {...register("firstName", {
              required: true,
            })}
            placeholder="First Name"
            required
          />
          <input
            type="text"
            className="form-control text-light"
            name="lastName"
            {...register("lastName", {
              required: true,
            })}
            placeholder="Last Name"
          />

          {errors.firstName && (
            <div className=" text-center">
              <small className="text-danger">{errors.firstName?.message}</small>
            </div>
          )}
          {errors.lastName && (
            <div className=" text-center">
              <small className="text-danger">{errors.lastName?.message}</small>
            </div>
          )}
        </div>
        <div className="input-group">
          <div className="input-group-prepend">
            <label className="input-group-text pr-2" htmlFor="gender">
              Head Teacher
            </label>
          </div>
          <Controller
            control={control}
            name="headTeacherId"
            render={({ field: { onChange, value, ref } }) => (
              <Select
                inputRef={ref}
                className="react-select info"
                classNamePrefix="react-select"
                onChange={({ value }) => {
                  onChange(value);
                }}
                value={teacherSelections?.find((opt) => opt.value === value)}
                isDisabled={isLoadingTeacherSelections}
                options={teacherSelections}
              />
            )}
          />
        </div>

        <FormEntry
          marginClass="mb-2"
          formLabel="Student No"
          placeholder="Student Number"
          name="studentNo"
          register={register}
          required={true}
          error={errors.studentNo}
          type="text"
        />
        <div className="input-group">
          <div className="input-group-prepend">
            <label className="input-group-text pr-2" htmlFor="gender">
              Parent
            </label>
          </div>
          <Controller
            rules={{
              required: {
                value: true,
                message: "Parent is required",
              },
            }}
            control={control}
            name="parentId"
            render={({ field: { onChange, value, ref } }) => (
              <Select
                inputRef={ref}
                className="react-select info"
                classNamePrefix="react-select"
                onChange={({ value }) => {
                  onChange(value);
                }}
                value={parentOptions?.find((option) => option.value === value)}
                isDisabled={isParentLoading || isStudentLoading}
                options={parentOptions}
              />
            )}
          />
        </div>
        {errors.parentId && (
          <div className=" text-center">
            <small className="text-danger">{errors.parentId?.message}</small>
          </div>
        )}

        <div className="input-group mb-3">
          <div className="input-group-prepend">
            <label className="input-group-text pr-2" htmlFor="centre">
              Centre
            </label>
          </div>
          <Controller
            rules={{
              required: {
                value: true,
                message: "Centre is required",
              },
            }}
            control={control}
            name="centreId"
            render={({ field: { ref, value, onChange } }) => (
              <Select
                inputRef={ref}
                className="react-select info"
                classNamePrefix="react-select"
                value={centres?.find((c) => c.value === value)}
                onChange={(val) => onChange(val.value)}
                options={centres || []}
                isClearable={false}
                placeholder="Select centres...."
                isDisabled={isCentreLoading}
              />
            )}
          />
        </div>
        {errors.centreId && (
          <div className=" text-center">
            <small className="text-danger">{errors.centreId?.message}</small>
          </div>
        )}
      </Col>
      <Col md={3} className="d-flex text-center">
        <FormGroup>
          <Label for="nftPic" className="text-white">
            NFT Picture
          </Label>
          <ReactRoundedImage className="" image={nftPath} roundedSize="1" />
        </FormGroup>
      </Col>
      <Col md={3} className="text-center">
        <FormGroup>
          <Label for="imgPath" className="text-white">
            Profile Picture
          </Label>
        </FormGroup>
        <Controller
          control={control}
          name="imgPath"
          render={({ field: { value, onChange } }) => (
            <div>
              <input
                ref={fileInputRef}
                className="d-none"
                onChange={(e) => {
                  const file = e.target.files[0];
                  const reader = new FileReader();
                  reader.onloadend = () => {
                    onChange(reader.result);
                  };
                  reader.readAsDataURL(file);
                }}
                type="file"
                accept="image/*"
              />
              {value ? (
                <ProtectedImg
                  style={{
                    cursor: "pointer",
                    borderRadius: "100%",
                    aspectRatio: "1/1",
                    objectFit: "cover",
                    width: "100%",
                  }}
                  src={value ?? defaultImage}
                  onClick={() => fileInputRef.current?.click()}
                />
              ) : (
                <ProtectedImg
                  style={{
                    cursor: "pointer",
                    borderRadius: "100%",
                    aspectRatio: "1/1",
                    objectFit: "cover",
                    width: "100%",
                  }}
                  src={defaultImage}
                  onClick={() => fileInputRef.current?.click()}
                />
              )}
            </div>
          )}
        />
        {errors.imgPath && (
          <div className=" text-center">
            <small className="text-danger">{errors.imgPath?.message}</small>
          </div>
        )}
      </Col>
    </Row>
  );
};
